import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";
import CpntDragAndDropLists from "../../../components/CpntDragAndDropLists";
import { IKeyValueLibelle } from "../../../models/interfaces/IKeyValueLibelle";
import { toast } from "react-toastify";
import SpinnerEditeurPro from "../../FO/components/SpinnerEditeurPro";
import { useCompteUpdateMarquesMutation, useFetchCompteGetMarquesQuery } from "../../../redux/slice/api/FO/compteApi";
import { useFetchSocieteGetAllMarquesQuery } from "../../../redux/slice/api/FO/societeApi";
import { IMarque } from "../../../models/interfaces/IMarques";


interface IProps {
  IdCompte: number;
  refetch: boolean;
}


const FOCompteSocieteTabMarques: React.FC<IProps> = ({ IdCompte,refetch }) => {

  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
 

    /* */
    const [sourceMarques, setSourceMarques] = useState<IKeyValueLibelle[]|undefined>([]);
    const [destinationMarques, setDestinationMarques] = useState<IKeyValueLibelle[]|undefined>([]);
    const [destinationMarquesResult, setDestinationMarquesResult] = useState<IKeyValueLibelle[]|null>(null);
    //const [searchParams, setSearchParams] = useState<IFilterSociete>();
    const [fetchSocieteMarques, setFetchSocieteMarques] = useState(refetch);
  
  
    const { data: SocietesResult, isFetching: SocietesisFetching, error: Societeserror } = useFetchSocieteGetAllMarquesQuery(null, {
      refetchOnMountOrArgChange: true,
      skip: !keycloakinitialized || !keycloak.authenticated ,//|| searchParams === null || searchParams === undefined,
    });
  
  
    const { data: CompteMarqueResult, isFetching: CompteMarqueResultFetching, error: CompteMarqueResultError, refetch:refetchCompteMarque} = useFetchCompteGetMarquesQuery(IdCompte, {
      refetchOnMountOrArgChange: true,
      skip: !keycloakinitialized || !keycloak.authenticated || IdCompte === 0 || fetchSocieteMarques === false,
    });
  
    useEffect(() => {
      //setFetchSearchMarques(refetch);
      setFetchSocieteMarques(refetch);
    }, [refetch])
  
  
    const [
      UpdateMarquesMutation,
      {
        isSuccess: isSuccessUpdateMarques,
        error: errorUpdateMarques,
        isLoading:isLoadingUpdateMarques
      },
    ] = useCompteUpdateMarquesMutation();
  
  
    const PaintSource = () => {
      setSourceMarques([]);

      const Tasks: React.SetStateAction<IKeyValueLibelle[] | undefined> = [];

      SocietesResult?.Marques?.forEach((elem: IMarque) => {
        Tasks.push({
           value:elem.Id?.toString(),
            key: "0-7"+elem.IdExterne?.toString(), 
            Libelle: elem.Libelle 
        });
      });
      
      setSourceMarques(Tasks);



    }
  
    const PaintDestination = () => {
      setDestinationMarques([]);

      const Tasks: React.SetStateAction<IKeyValueLibelle[] | undefined> = [];

      CompteMarqueResult?.Marques?.map((elem:IMarque) => {
        Tasks.push({
          value:elem.Id?.toString(),
          key: "0-7"+elem.IdExterne?.toString(), 
          Libelle: elem.Libelle 
        });
      });

      setDestinationMarques(Tasks);

    }
    
  
    useEffect(() => {
      if (!SocietesisFetching && Societeserror === undefined) {
        PaintSource();
      } else {
        setSourceMarques(undefined);
      }
    }, [SocietesResult,isSuccessUpdateMarques])
  
    useEffect(() => {
      if (!CompteMarqueResultFetching && CompteMarqueResultError === undefined) {
        PaintDestination();
      } else {
        setDestinationMarques(undefined);
      }
    }, [CompteMarqueResult,isSuccessUpdateMarques])
  


  
  useEffect(() => {
      if (errorUpdateMarques !== undefined) {
        toast.warn("Les modifications n'ont pas été prises en compte");
        //setUpdateError(errorUpdateBO)
      }
  }, [errorUpdateMarques])
  
  useEffect(() => {
    if (isSuccessUpdateMarques) {
      toast.success("Les modifications ont bien été prises en compte.");
      refetchCompteMarque();
      // setPublication(publication);
      // setUpdateSuccess(true);
    }
  }, [isSuccessUpdateMarques])
  
  
    useEffect(() => {
      
      if (destinationMarquesResult) {
        UpdateMarquesMutation({
          IdCompte:IdCompte ?? -1,
          //IdsMarque:destinationMarquesResult.map(m => parseInt(m.value))
          Marques: destinationMarquesResult?.map(m => ({
            IdExterne: parseInt(m.value),
            Libelle: m.Libelle
        }))
        });
      }
    }, [destinationMarquesResult])
  
    const AnnulerCommand = () => {
      PaintDestination();
      PaintSource();
    }
 
  return (
    <>
          {isLoadingUpdateMarques //|| CompteMarqueResultFetching || SocietesisFetching
          ?
            <SpinnerEditeurPro text="Mise à jour en cours..." />
          : 
          <CpntDragAndDropLists 
          titresource="Marque(s) disponible" 
          source={sourceMarques} 
          sourceIsFetching={SocietesisFetching}
          titredestination="Marque(s) Attribuée(s)" 
          destination={destinationMarques} 
          destinationIsFetching={CompteMarqueResultFetching} 
          cmdValider={setDestinationMarquesResult} 
          cmdAnnuler={AnnulerCommand} />
          } 
          
    </>
  )
    
}; 

export default FOCompteSocieteTabMarques;

